// extracted by mini-css-extract-plugin
export default {"button":"R8k8MfU7ixq27UcrhfVO","root":"IcKFftmsSGKio4AX0sev","text":"NQ9H_w3w7SaC28N6jl_r","endTag":"ZeSVpPfSXFf3tbAqV9KE"};